import { render, staticRenderFns } from "./CustomerCheque.vue?vue&type=template&id=537a5bf2&scoped=true"
import script from "./CustomerCheque.vue?vue&type=script&lang=js"
export * from "./CustomerCheque.vue?vue&type=script&lang=js"
import style0 from "./CustomerCheque.vue?vue&type=style&index=0&id=537a5bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a5bf2",
  null
  
)

export default component.exports